import { __extends } from "tslib";
import { exposeGetters } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';

var AddonsTheme =
/** @class */
function (_super) {
  __extends(AddonsTheme, _super);

  function AddonsTheme() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(AddonsTheme, "logoDividerBg", {
    get: function get() {
      return this.tdDividerBg;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme, "spinnerOldBgColor", {
    //#endregion
    //#region Spinner
    get: function get() {
      return this.grayXLight;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme, "spinnerOldColor", {
    get: function get() {
      return this.red;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme, "spinnerOldDimmedColor", {
    get: function get() {
      return this.gray;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AddonsTheme, "spinnerOldCaptionColor", {
    get: function get() {
      return this.gray;
    },
    enumerable: true,
    configurable: true
  }); //#region TopBar

  AddonsTheme.tbBg = '#fff';
  AddonsTheme.tbShadow = '0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 8px 0 rgba(0, 0, 0, 0.1)';
  AddonsTheme.tdDividerBg = '#dfdfdf';
  AddonsTheme.tbDividerHeight = '30px';
  AddonsTheme.tbDividerMarginX = '0px';
  AddonsTheme.tbHeight = '50px';
  AddonsTheme.tbItemPaddingX = '10px';
  AddonsTheme.tbItemMarginX = '0';
  AddonsTheme.tbPaddingX = '15px';
  AddonsTheme.tbPaddingY = '0';
  AddonsTheme.tbMarginBottom = '20px';
  AddonsTheme.tbItemIconGap = '4px';
  AddonsTheme.tbItemBorderRadius = '0';
  AddonsTheme.tbItemActionBackground = 'rgba(0, 0, 0, 0.06)';
  AddonsTheme.tbOrganizationsCaptionLegacyPadding = '0px'; // deprecated, remove after 3.0

  AddonsTheme.tbMenuSeparatorMarginX = '12px';
  AddonsTheme.tbMenuSeparatorMarginY = '4px';
  AddonsTheme.tbMenuSeparatorColor = 'rgba(0, 0, 0, 0.05)';
  AddonsTheme.tbMenuItemHoverBg = 'rgba(0, 0, 0, 0.05)';
  AddonsTheme.tbMenuItemHoverColor = '#222';
  AddonsTheme.tbMenuItemPaddingX = '12px'; //#endregion
  //#region Logotype

  AddonsTheme.logoColor = '#000';
  AddonsTheme.logoHoverColor = '#000';
  AddonsTheme.logoDividerHeight = '60%';
  AddonsTheme.logoDividerWidth = '1px';
  AddonsTheme.logoDividerMarginX = '15px';
  AddonsTheme.logoWidgetPaddingX = '10px';
  AddonsTheme.logoButtonHeight = '100%';
  AddonsTheme.logoButtonWidth = '20px';
  AddonsTheme.logoButtonMarginLeft = '0px';
  AddonsTheme.logoButtonActionBorderRadius = '0';
  AddonsTheme.logoButtonActionBackground = 'rgba(0, 0, 0, 0.06)';
  AddonsTheme.spinnerOldFontSizeSmall = '14px';
  AddonsTheme.spinnerOldFontSizeMedium = '14px';
  AddonsTheme.spinnerOldFontSizeLarge = '14px';
  AddonsTheme.spinnerOldLineHeightSmall = 'inherit';
  AddonsTheme.spinnerOldLineHeightMedium = 'inherit';
  AddonsTheme.spinnerOldLineHeightLarge = 'inherit';
  AddonsTheme.spinnerOldCaptionGapSmall = '5px';
  AddonsTheme.spinnerOldCaptionGapMedium = '0px';
  AddonsTheme.spinnerOldCaptionGapLarge = '0px'; //#endregion
  //#region UserAvatar

  AddonsTheme.userAvatarSize = '32px';
  AddonsTheme.userAvatarBorderRadius = '100%';
  AddonsTheme.userAvatarBackground = 'transparent';
  AddonsTheme.userAvatarHoverBackground = '#222';
  AddonsTheme.userAvatarActiveBackground = '#222';
  AddonsTheme.userAvatarColor = '#222';
  AddonsTheme.userAvatarHoverColor = '#fff';
  AddonsTheme.userAvatarActiveColor = '#fff';
  return AddonsTheme;
}(
/** @class */
function () {
  function class_1() {}

  return class_1;
}());

export { AddonsTheme };
export var REACT_UI_ADDONS_THEME_KEY = '__IS_REACT_UI_ADDONS_THEME__';
export var markAsAddonsTheme = function markAsAddonsTheme(theme) {
  var _a;

  return Object.create(theme, (_a = {}, _a[REACT_UI_ADDONS_THEME_KEY] = {
    value: true,
    writable: false,
    enumerable: false,
    configurable: false
  }, _a));
};
export var isAddonsTheme = function isAddonsTheme(theme) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  //@ts-ignore
  return theme[REACT_UI_ADDONS_THEME_KEY] === true;
};
export var AddonsThemeInternal = exposeGetters(AddonsTheme);